import SelectizeExtension from "./SelectizeExtension";
export default SelectizeExtension;